import { Divider } from '~/components/granular';
import type { DropdownObjectItem } from '../..';
import { CheckboxItem, TextItem, useDropdownContext } from '../..';

function getShortcutItemLabel(item: Array<DropdownObjectItem | string>) {
  return item.map((i) => (typeof i === 'string' ? i : i.label)).join(' / ');
}

function getShortcutItemValue(item: Array<DropdownObjectItem | string>) {
  return item.map((i) => (typeof i === 'string' ? i : i.value)).join(' / ');
}

export function DropdownShortcuts({ className, checkboxItems }: { className?: string; checkboxItems?: boolean }) {
  const { shortcutItems } = useDropdownContext();

  return (
    <div>
      {shortcutItems?.map((item: Array<DropdownObjectItem | string>) => {
        const itemLabel = getShortcutItemLabel(item);
        const itemValue = getShortcutItemValue(item);
        const itemKey = `${itemLabel.toLocaleLowerCase().replace(/\s/g, '-')}-${itemValue}`;

        const Component = checkboxItems ? CheckboxItem : TextItem;

        return (
          <Component
            className={className}
            item={{ isShortcut: true, label: itemLabel, value: itemValue }}
            key={itemKey}
          />
        );
      })}
      <Divider className="mt-1 pt-0 pb-1" />
    </div>
  );
}
